import { MAX_EXPIRE_DATE_TIME } from 'src/app/core/constants/date';

export const resetTimeToDate = (date: Date | number) => {
  const d = new Date(date);

  d.setHours(0, 0, 0, 0);

  return d.getTime();
};

export const addFromDayToDayToEvent = <
  T extends { fromDate: number; toDate: number },
>(
  event: T
): T & { fromDay: number; toDay: number } => {
  const today = resetTimeToDate(new Date());
  const fromDay = resetTimeToDate(new Date(event.fromDate));

  return {
    ...event,
    fromDay: fromDay < today ? today : fromDay,
    toDay: resetTimeToDate(new Date(event.toDate)),
  };
};

export const getTodayTime = () => Date.now();

export const getMaxExpireDateTime = () => MAX_EXPIRE_DATE_TIME;
